import './src/styles/global.css'
import "./language-tabs.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '@mdx-js/react';

import { wrapRootElement as wrap } from "./wrap-root-element";

export const wrapRootElement = wrap;